import BulkAction from '@/components/component/admin/BulkAction/BulkAction.vue'
import SearchDropdown from '@/components/component/admin/SearchDropdown/SearchDropdown.vue'
const countrydata = require('countrydata');
import constants from '../../../../libs/constant/constants'
import { message} from '@/libs/helper'
import {bulkUpdate, getLanguages} from '@/libs/api/api'
import {isEmpty, uniqBy, cloneDeep, uniq, sortBy, filter} from 'lodash'
export default{
    name: 'BulkUpdate',
    components: {BulkAction, SearchDropdown},
    props: {
        module: {
            type: String,
            default: 'PUBLISHER'
        },
        displayList: {
            type: Object
        },
        markedTableItems: {
            type: Array,
            default: () => {}
        }
    },
    beforeMount() {
        if(this.module === constants.PUBLICATION.key || this.module === constants.ARTICLE.key){
            getLanguages()
                .then((response)=>{
                    this.languages = sortBy(cloneDeep(response.languages), 'name') || []
                })
                .catch((error)=>{
                    console.log('error', error);
                })
        }
    },
    computed: {
        table () {
            return this.$store.getters.getTableData.filter(item => {
                if (new Set(this.markedTableItems).has(item._id)) return true
            })
        }
    },
    data() {
        return {
            countrydata,
            isEmpty,
            step: 1,
            publisherFieldsNotToShow: false,
            adminAction: '',
            authorAction : '',
            publicationAction: '',
            country: '',
            language: '',
            date: '',
            languageName: '',
            publications: [],
            selectedLanguage: {},
            selectedCountry: {},
            languages: [],
            admin: {},
            publisher: {},
            publication: {},
            authors: [],
            checkedData: [],
            markedItems: [],
            isConfirm: false,
            isFinal: false,
            isProgress: false,
            progress: 0,
            fields: {
                name: '',
                first_name: '',
                last_name: '',
                middle_name: '',
                city: '',
                short_description: '',
                biography: '',
                copyright: '',
                registration: '',
                title: '',
                subtitle: '',
                description: ''
            },
            pickerOptions: {
                disabledDate (date) {
                  return new Date(date) > new Date()
                }
            },
            // listing properties
            isListing: false,
            metaConfirmed: true,
            metaChecked: false,
            action: '',
            actionValue: '',
            selectedMetaData: {}
        }
    },
    methods: {
        getModuleName (module) {
            if (module !== null || module !== undefined || module !== '') {
                return `${module.charAt(0)}${module.slice(1).toLowerCase()}s`
            }
            return ''
        },
        changeAction(type, value) {
            switch(type) {
                case 'ADMIN':
                    this.adminAction = value
                    break;
                case 'AUTHOR':
                    this.authorAction = value
                    break
                case 'PUBLICATION': 
                    this.publicationAction = value
            }
        },
        changeValues(type) {
            if (!this.markedItems.includes(type)) {
               this.markedItems.push(type)
            } else {
                const index = this.markedItems.indexOf(type)
                if (index > -1) this.markedItems.splice(index, 1)
            }
        },
        changeCheckedValues (type) {
            if (!this.checkedData.includes(type)) {
                this.checkedData.push(type)
             } else {
                 const index = this.checkedData.indexOf(type)
                 if (index > -1) this.checkedData.splice(index, 1)
             }
        },
        buttonAction (type) {
            switch (type) {
                case 'back':
                    this.step = 1
                    this.isConfirm = false
                    break
                case 'cancel':
                    // this.clearField()
                    this.$emit('close')
                    break
                case 'next':    
                    if (!isEmpty(this.markedItems)) {
                        this.checkedData = cloneDeep(this.markedItems)
                        this.step = 2
                        this.isConfirm = true
                    }
                    break
                case 'done':
                    this.$emit('refreshPage')
                    this.$emit('close')
                    break    
            }
        },
        handleSearch (type, item) {
            switch (type) {
                case 'USER': 
                    this.admin = item
                break
                case 'PUBLICATION':
                    if (this.module === constants.ARTICLE.key || this.module === constants.PUBLISHER.key) {
                        this.publication = item
                    } else {
                        this.publications.push(item)
                        this.publications = uniqBy(this.publications, '_id')
                    }                   
                break
                case 'PUBLISHER':
                    this.publisher = item
                break
                case 'AUTHOR':
                    this.authors.push(item)
                    this.authors = uniqBy(this.authors, '_id')
                break
            }
        },
        confirmButton () {
            this.isProgress = true 
            this.progress = 15  
            let body = this.getBody()
            if (isEmpty(this.checkedData) || isEmpty(body)) {
                this.isProgress = false
                message(this, constants.messageType.ERROR, "No fields added for updation")
                return
            }
            let entity_ids = uniq(this.markedTableItems)
            body.entity_ids = entity_ids  
            bulkUpdate(constants[this.module].value.toLowerCase(),body).then(() => {  
                this.progress= 100  
                this.step = 3
                this.isFinal = true
                this.isProgress = false
            }).catch(error=>{
                console.warn('error', error)
                this.isProgress = false
            })
        },
        getBody () {
            let body = {}
            let data = cloneDeep(this.checkedData)
            if (data.includes('first_name') && this.fields.first_name !== '') body.first_name = this.fields.first_name
            if (data.includes('middle_name') && this.fields.middle_name !== '') body.middle_name = this.fields.middle_name
            if (data.includes('last_name') && this.fields.last_name !== '') body.last_name = this.fields.last_name
            if (data.includes('city') || data.includes('country')){
                let address = {}
                if (data.includes('city') && this.fields.city !== '') address.city = this.fields.city
                if (data.includes('country') && !isEmpty(this.selectedCountry)) {
                    address.country_code = this.selectedCountry.iso3166.alpha2 || this.selectedCountry.iso3166.alpha3
                    address.country_name = this.selectedCountry.name.en
                }
                if (!isEmpty(address)) body.address = address
            } 
            // if (data.includes('country') && this.country !== '') body.country = this.country
            if (data.includes('biography') && this.fields.biography !== '') body.biography = this.fields.biography
            if (data.includes('short_description') && this.fields.short_description !== '') body.short_description = this.fields.short_description
            if (data.includes('name') && this.fields.name !== '') body.name = this.fields.name
            if (data.includes('copyright') && this.fields.copyright !== '') body.copy_right = this.fields.copyright
            if (data.includes('registration') && this.fields.registration !== '') body.registration_number = this.fields.registration
            if (data.includes('title') && this.fields.title !== '') body.title = this.fields.title
            if (data.includes('subtitle') && this.fields.subtitle !== '') body.sub_title = this.fields.subtitle
            if (data.includes('description') && this.fields.description !== '') body.description = this.fields.description
            if (data.includes('pub_date') && this.date !== '') body.pub_date = this.date
            if (data.includes('language') && !isEmpty(this.selectedLanguage)) {
                let language = cloneDeep(this.selectedLanguage)
                language.language_id = this.selectedLanguage._id
                language.operation = 'ADD'
                delete language._id
                body.language = language
            }
            if (data.includes('admin') && this.adminAction !== '') {
                if (this.adminAction === 'Remove') {
                    body.user_admin_action = {
                        action: constants.ACTION[this.adminAction],
                        user_id: ''
                    } 
                } else if (this.adminAction === 'ReplaceWith' && !isEmpty(this.admin)) 
                body.user_admin_action = {
                    action: constants.ACTION[this.adminAction],
                    user_id: this.admin._id
                } 
            }

            if (data.includes('author') && !isEmpty(this.authors) && this.authorAction !== '') {
                body.authors = {
                    action: constants.ACTION[this.authorAction],
                    author_id: this.authors.map(a => a._id)
                }
            }

            if (data.includes('publication')) {
                if (this.module === 'ARTICLE' || this.module === 'PUBLISHER') {
                    if (!isEmpty(this.publication)) {
                        body.publication = this.publication._id
                    }
                } else {
                    if (!isEmpty(this.publications) && this.publicationAction !== '') {
                        body.publications = {
                            action: constants.ACTION[this.publicationAction],
                            publication_ids: this.publications.map(pub => pub._id)
                        }
                    }
                }
                
            }
            if (data.includes('publisher') && !isEmpty(this.publisher)) {
                body.publisher = this.publisher._id
            }
            return body
        },
        changeLanguage (language) {
            this.selectedLanguage = cloneDeep(language)
            this.language = language.display_name
            this.languageName = language.display_name
        },
        querySearch (query, cb) {
            if (query !== '' && query !== null && query.length > 1 ) {
                let results = []
                let languages = cloneDeep(this.languages)
                if (!isEmpty(languages)) {
                   results = filter(languages, (language) => {
                        return language.display_name.toLowerCase().includes(query.toLowerCase())
                    })
                }
                cb(results)
            }
        },
        selectCountry (item) {
            this.selectedCountry = cloneDeep(item)
            this.country = item.name.en || ''
        },
        querySearchCountry: async function (search, cb) {
            if (search === '' && search === null && search.length < 2) return 
            let results = []
            if (!isEmpty(countrydata.all)) {
                let country = cloneDeep(countrydata.all)
                 results = await filter(country, (c) => {
                   return c.name.en.toLowerCase().includes(search.toLowerCase())
                })
            }
            cb(results)
        },
        /**
         * to change the sub header options
         * @param {*} isTrue 
         */
        changeOptions (isTrue) {
            // to change the listing
            this.isListing = isTrue
            this.isConfirm = false
            this.isProgress = false
            this.isFinal = false
        },

        /**
         * disable fields of listing form
         */
        isDisabled () {
            if (this.metaChecked && !isEmpty(this.selectedMetaData) && this.action !== '') return false
            return true
        },

        /**
         * to change the action of listing dropdown
         */
        changeListingAction (action) {
            this.actionValue = constants.REPLACE_META[action].value 
        },
        handleListingSearch (type, item) {
            this.selectedMetaData = item
        },
        /**
         * button of listing module
         * @param {*} type 
         */
        listingButton (type) {
            switch (type) {
                case 'next': 
                    this.isConfirm = true
                    this.step = 2
                break
                case 'back':
                    this.isConfirm = false
                    this.step = 1
                break
                case 'confirm':
                    if (this.module === 'AUTHOR' || this.module === 'PUBLICATION' || this.module === 'PUBLISHER') {
                        this.replaceMetaData()
                    }
                break
            }
        },
        /**
         * to replace listing
         */
        replaceMetaData: async function () { 
            try {
                 if (this.action === '' || isEmpty(this.selectedMetaData)) {
                     message(this, constants.messageType.ERROR, "Some fields are missing")
                     return
                 }
                //  if (this.selectedMetaData._id === this.metaData._id) {
                //      message(this, constants.messageType.ERROR, `Same ${this.module} should not be selected`)
                //      return
                //  }
                 this.skip = 15
                 this.isProgress = true
                 let body = await this.getListingBody(this.module)
                 await bulkUpdate(this.module.toLowerCase(), body)
                 this.skip = 100 
                 this.isProgress = false
                 this.step = 3
                 this.isFinal = true
            } catch (error) {
                 console.error(error)
                 this.isProgress = false
            }
             
         },
         getListingBody (module) {
             let ids = []
             this.table.map(item => {
                if (item._id !== this.selectedMetaData._id) ids.push(item._id)
            })
            let body = {
                entity_ids: ids
            }
            switch (module) {
                case 'AUTHOR': 
                    body.replace = {
                        action: this.action,
                        author_id: this.selectedMetaData._id
                    }
                break
                case 'PUBLICATION': 
                    body.replace = {
                        action: this.action,
                        publication_id: this.selectedMetaData._id
                    }
                break
                case 'PUBLISHER': 
                    body.replace = {
                        action: this.action,
                        publisher_id: this.selectedMetaData._id
                    }
                break
            }
            return body
        }
    }
}